(function() { window.GUID_e0158e93_d6a8_463a_95e1_16a15b5ca654 = { getGuid: function() { return "e0158e93-d6a8-463a-95e1-16a15b5ca654"; } }; })();
var CS;
(function (CS) {
    var lagNames = {}; //Dictionary<string, number>
    /**
     * Ajoute un délais à un call. Si vous l'appelez 2 fois avec le même 'uniqueName', seulement le 2e seras executé. Retourne le TimerHandle; peut être annulé avec 'clearTimeout(TimerHandle)'.
     * @param uniqueName
     * doit être unique à travers l'application. Utilisez quelque chose comme {Page}-{Method}-Autre
     * @param lagTime
     * temps en ms
     * @param callback
     * call ce callback après le lagTime
     */
    function Lag(uniqueName, lagTime, callback) {
        if (!uniqueName) {
            console.error("uniqueName is required");
            return;
        }
        let localTimeOutId = lagNames[uniqueName];
        clearTimeout(localTimeOutId);
        localTimeOutId = window.setTimeout(callback, lagTime);
        lagNames[uniqueName] = localTimeOutId;
        return localTimeOutId;
    }
    CS.Lag = Lag;
})(CS || (CS = {}));

//# sourceMappingURL=cs-lag.js.map
